// Implements DESIGN.md "Loading states" — skeletons match the shape of
// the content they replace; never bare "Loading…" text.
import { Skeleton } from '@/components/ui/Skeleton';

interface CardListSkeletonProps {
  rows?: number;
  className?: string;
}

export function CardListSkeleton({ rows = 3, className = '' }: CardListSkeletonProps) {
  return (
    <ul className={`space-y-2 ${className}`} aria-label="Loading list">
      {Array.from({ length: rows }, (_, i) => (
        <li key={i} className="card flex items-center gap-4">
          <Skeleton className="h-10 w-10 rounded-[var(--radius)]" />
          <div className="flex-1 space-y-2">
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="h-3 w-2/3" />
          </div>
        </li>
      ))}
    </ul>
  );
}
